<template>
    <form class="announcement-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['name']}">
            <label for="question" class="col-sm-2 control-label">Nombre  *</label>
            <div class="col-sm-8">
                <input type="text" :maxlength="190" class="form-control" id="name" v-model="data.name">
                <div class="help-block" v-for="e in errors['name']">{{e}}</div>
            </div>
        </div>        
        <div class="form-group" :class="{'has-error': errors['description']}">
            <label for="description" class="col-sm-2 control-label">Descripción *</label>
            <div class="col-sm-10">
                <editor  id="description" v-model="data.description"></editor>

                <div class="help-block" v-for="e in errors['description']">{{e}}</div>
            </div>
        </div>
        

        <div class="form-group">
            <div class="row">
                <label class="col-sm-2 control-label">Previsualización</label>
            </div>
            <div class="row">
            <div class="col-sm-12">
                <div class="info_covid-19">
                    <link rel="stylesheet" type="text/css" href="/css/etapas_corona.css"> 
                    <div class="header-covid">
                        <div class="container">
                        <h1 > {{data.name}}  </h1>
                        </div>
                    </div> 
                 <div  class="container">
                    <div class="row descripcion">
                        <div class="col-12 col-md-12">
                            <p v-html="data.description" > </p> 
                        </div>
                    </div>
                 </div>
                </div>


            </div>
        </div>
    </div>
   
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" :href="'backend/faqs/'">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>

    .el-date-picker{
        display: block;
    }
    .el-select{
        display: block;
    }

    .card {
        font-family: 'Roboto';
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: none;
        border-radius: 10px;
        padding: 12px 18px 18px;
        margin-bottom: 25px;
        font-weight: 400;
        overflow: hidden;
        -webkit-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        -moz-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
    }
    .accordion-page .card.stage-block .btn-link, main #page .accordion-page .card.stage-block .card-body {
        padding: 30px 20px 30px 30px;
        background-color: transparent;
    }
    .accordion-page .card a.btn-link {
        display: block;
        color: #000;
        text-decoration: none;
    }
    .life-stages .accordion-page .card.stage-block a.btn-link .card-header h2 {
        color: #000000;
        font-size: 28px;
        margin: 0;
        font-family: Roboto Slab,sans-serif;
    }
    .card.stage-block a, .card.stage-block a:hover, .card.stage-block a h2, .card.stage-block a:hover h2 {
        text-decoration: underline!important;
        color: #240003!important;
    }
    
    .life-stages.container .beneficiaries {
        border-bottom: none;
        width: 85%;
    }
    .faq-alert.life-stages .line-left {
        background: #0080ec;
    }
    .line-left {
        height: 100%;
        position: absolute;
        top: 0;
        width: 12px;
        background: #0080ec;
        left: 0;
    }
    
    .card.stage-block .know-more {
        position: absolute;
        display: block;
        right: 20px;
        top: calc(50% - 10px);
        color: #337ab7;
    }
    .accordion-page .card.stage-block .btn-link, main #page .accordion-page .card.stage-block .card-body {
        padding: 30px 20px 30px 30px;
        background-color: transparent;
    }
    .card-body {
        margin-left: 13px;
        padding-top: 18px;
        padding-bottom: 13px;
    }
    .card.stage-block p {
        font-size: 16px;
    }
</style>
<script>
    import Vue from 'vue';
    import Editor from "./Editor.vue"; 
    import { Message } from "element-ui";
    import { Loading } from 'element-ui';
    
    var url2 = baseUrl;
    export default {
        data: function(){
            const data = {                
                id: null,
                name :'',
                description:'',
                question: '',
                answer: '',
                active: false,
                order: null,
                created_at: null,
                updated_at: null,
            };
            
            return{
                data: _.assign(data, this.faq),
                disabled: false,
                must_delete: false,
                errors: {},
                positions: [],
                loading: false
            }
        },
        
        props: ['faq','edit'],
        methods:{ 
            
            submit: function(){
                var self = this;
                var tmpdes = '';

                var errores = {};
                
                if (!self.data.name || self.data.answer.name == 0 ) {
                    errores["name"] = ["Debe ingresar un nombre."];
                }
                if (/^\s+$/.test(self.data.name)){
                  errores["name"] = ["El nombre no puedes ser solo espacios en blanco ."];
                }
                if (!self.data.description || self.data.description.length == 0) {
                    errores["description"] = ["Debe ingresar una descripción."];
                }
                if (self.data.description.length > 1024) {
                    errores["description"] = ["texto descripción muy grande por favor corrija"];
                }
                tmpdes = self.data.description.replace('<p>' , '');
                tmpdes = tmpdes.replace('</p>' , '');
                console.log('tmpdes' , tmpdes);
                if (/^\s+$/.test(tmpdes)){
                  errores["description"] = ["la descripción no pueden ser solo espacios en blanco."];
                }
                if (_.size(errores) > 0) {
                    self.errors = errores;
                    self.$message.error(
                    "Revise los errores en el formulario para continuar."
                    );
                    return false;
                }

               
                axios({
                    url: self.edit ? 'backend/faqs/'+self.faq.id:'backend/faqs',
                    method: self.edit ? 'PUT' : 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                   self.errors = error.response.data.errors;
                });
            },

        },
        components:{
            Editor
        },
        mounted() {
            var self = this;
        }
    }
</script>